import { useCallback, useEffect, useState } from 'react';

import Client from '@atlaskit/link-provider/client';

import { useProductDependencies } from '../../../../controllers/use-product-dependencies';

interface TitlePrefix {
	text?: string;
}

interface ResolvedDataObject {
	data: {
		'atlassian:titlePrefix'?: TitlePrefix;
	};
}

interface UseSmartCardsEmojiResult {
	emojiId: string | null;
}

const sanitizeEmojiValue = (value: string | undefined) =>
	(value && value.replace(/['"]+/g, '').replace(/null/, '')) || '';

export const useSmartCardEmoji = (link: string): UseSmartCardsEmojiResult => {
	const { submitError } = useProductDependencies();
	const [emojiId, setEmojiId] = useState<string>();

	const getEmoji = useCallback(async () => {
		const client = new Client();
		try {
			const queriedEmojiObject = (await client.fetchData(link)) as ResolvedDataObject;
			setEmojiId(sanitizeEmojiValue(queriedEmojiObject.data['atlassian:titlePrefix']?.text));
		} catch (error) {
			submitError?.(error as Error);
		}
	}, [link, submitError]);

	useEffect(() => {
		if (!!link) {
			void getEmoji();
		}
	}, [link, getEmoji]);

	return { emojiId: !!emojiId ? emojiId : null };
};
